
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {FacultyModel} from '../model/faculty.model';
import {API_URLS} from '../utils/api_url.util';
import { API_UTILS} from '../utils/api_utils.util'
import { TraineeMedicalProcedureCaseModel } from '../model/trainee_medical_procedure_case.model';
import { catchError } from 'rxjs/operators';
import { ProgramCategoryModel } from '../model/program_category.model';


/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class FacultyService {
  items:FacultyModel[];
 
  constructor(private http: HttpClient) {
    this.items = null;
  }
  mFaculty:FacultyModel=null;


/*

  getItemsByCategory(categoryId:number)
  {
     if(this.items)
     {
         return Promise.resolve(this.items)
     }

      // don't have the data yet
    return new Promise(resolve => {
      // We're using Angular Http provider to request the data,
      // then on the response it'll map the JSON data to a parsed JS object.
      // Next we process the data and resolve the promise with the new data.
      this.http.get(API_URLS.API_GET_HERITAGE_ITEM_BY_CATEGORY+'/admin'+'/${categoryId}')
        .map(res => <Array<HeritageItemModel>>res.json())
        .subscribe(data => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          this.items= data;
          resolve(this.items);
        });
    });


  }

  */

  
   getItems(): Observable<Array<FacultyModel>>{
    return this.http
      .get<Array<FacultyModel>>(API_URLS.API_GET_FACULTIES)
      .pipe(
        catchError(handleError)
      );

      
  }


  
  
  getProgramCategoryItems(): Observable<Array<ProgramCategoryModel>>{
    return this.http
      .get<Array<ProgramCategoryModel>>(API_URLS.API_PROGRAM_CATEGORIES)
      .pipe(
        catchError(handleError)
      );

      
  }


  
  getLogbBookFaculties(): Observable<Array<FacultyModel>>{
    return this.http
      .get<Array<FacultyModel>>(API_URLS.API_GET_LOGBOOK_FACULTIES)
      .pipe(
        catchError(handleError)
      );

      
  }


    



   addItem(item:FacultyModel): Observable<FacultyModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options =  { headers: headers };


    let items$ = this.http
      
      .post<FacultyModel>(API_URLS.API_ADD_FACULTY,body,options)
      .pipe(         catchError(handleError)       )
      return items$;  
    }

    
 

 editItem(item:FacultyModel): Observable<FacultyModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options =  { headers: headers };
    let id=item.Id;

    return this.http
      
      .post<FacultyModel>(API_URLS.API_EDIT_FACULTY,body,options)
      .pipe(         catchError(handleError)       );
     


    }




  removeItem(item:FacultyModel): Observable<FacultyModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options =  { headers: headers };
    let id=item.Id;

    let items$ = this.http
      .get<FacultyModel>(API_URLS.API_REMOVE_FACULTY+`/${id}`)
      .pipe(         catchError(handleError)       )
      return items$;
    
  }


 
  getFacultyTraineesMedicalProcedureCases(facultyId:string):Observable<TraineeMedicalProcedureCaseModel> {
    
    let items$ = this.http
       .get<TraineeMedicalProcedureCaseModel>(API_URLS.API_GET_FACULTY_TRAINEES_MEDICAL_PROCEDURE_CASES+`/${facultyId}`)
       .pipe(         catchError(handleError)       )
       return items$;
     
 
 
   }
 



/*

   getItemsByCategoryAndRegion(categoryId:number,regionId:number)
  {
     if(this.items)
     {
         return Promise.resolve(this.items)
     }

      // don't have the data yet
    return new Promise(resolve => {
      // We're using Angular Http provider to request the data,
      // then on the response it'll map the JSON data to a parsed JS object.
      // Next we process the data and resolve the promise with the new data.
      this.http.get(API_URLS.API_GET_HERITAGE_ITEM_BY_CATEGORY+'/admin'+'/${categoryId}'+'/${regionId}')
        .map(res => <Array<HeritageItemModel>>res.json())
        .subscribe(data => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          this.items= data;
          resolve(this.items);
        });
    });


  }

*/



 
}




// this could also be a private method of the component class
function handleError (error: HttpErrorResponse) {
  // log error
  // could be something more sofisticated
  console.error(error);

  return observableThrowError(error.error);

  
 }